<template>
    <span :class="className">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.71967 12.0303C5.42678 11.7374 5.42678 11.2626 5.71967 10.9697L8.68934 8L5.71967 5.03033C5.42678 4.73744 5.42678 4.26256 5.71967 3.96967C6.01256 3.67678 6.48744 3.67678 6.78033 3.96967L10.2803 7.46967C10.5732 7.76256 10.5732 8.23744 10.2803 8.53033L6.78033 12.0303C6.48744 12.3232 6.01256 12.3232 5.71967 12.0303Z" fill="#667488"/>
</svg>
</span>
</template>

<script>
export default {
    name: 'ArrowIcon',
    props: {
    width: {
      type: String,
      default: '16px'
    },
    height: {
      type: String,
      default: '16px'
    },
    className: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
/* Add any custom styles here */
</style>